import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import toast from "react-hot-toast";
import { V_URL } from "../../../../BaseUrl";

export const getLotDropdown = createAsyncThunk(
    '/user/get-lot-dropdown',
    async (payload) => {
        try {
            const myurl = `${V_URL}/prosafe/get-dropdown-lots`;
            const response = await axios({
                method: 'post',
                url: myurl,
                data: payload,
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    Authorization: "Bearer " + localStorage.getItem('PAY_USER_TOKEN')
                },
            });

            const lot = response.data;

            if (lot.success === true) {
                return lot;
            } else {
                throw new Error(lot);
            }
        } catch (error) {
            toast.error(error.response.data.message);
            return error;
        }
    }
);

const getLotDropdownSlice = createSlice({
    name: "getLotDropdown",
    initialState: {
        user: null,
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getLotDropdown.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getLotDropdown.fulfilled, (state, action) => {
                state.user = action.payload;
                state.loading = false;
                state.error = null;
            })
            .addCase(getLotDropdown.rejected, (state, action) => {
                state.user = null;
                state.loading = false;
                state.error = action.error.message;
            });
    }
})

export default getLotDropdownSlice.reducer;